CheckboxIndicator = {
  "jQuerySelector": "input.indicator",
  "html": function(id, disabled){
    return '<input id="' + id + '" type="checkbox" class="indicator" '+
    (disabled ? 'disabled' : '') +
    '></input>';
  }
}
